// 萌萌播添加摄像头相关接口
// http://rap2.10niu.cn/repository/editor?id=21&mod=438
// 萌萌播3.0.3接口文档
// http://note.youdao.com/noteshare?id=dbf69a1e655ec92b4df1b558b21d23aa
// AI智能行为识别盒子
// http://rap2.10niu.cn/organization/repository/editor?id=43&mod=631&itf=4102&from_wecom=1
// 添加重启时间
// http://rap2.10niu.cn/organization/repository/editor?id=21&mod=373&itf=2876
// http://rap2.10niu.cn/organization/repository/editor?id=21&mod=373&itf=2544
// http://rap2.10niu.cn/organization/repository/editor?id=21&mod=373&itf=4296

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

let baseRequest = (url, data) => {
	return requestByGateway({
		method: 'POST',
		url: `${config.api.face}${url}`,
		data: qs.stringify(data)
	});
};

const safety = {
	/**
	 * 管理页面
	 */
	// 1.获取列表数据（搜索）
	getMangeList(data) {
		return baseRequest('/console/v1/get-early-warning-rule-lists', data);
	},
	// 2.删除
	deleteDanger(data) {
		return baseRequest('/console/v1/del-danger-zone', data);
	},
	/**
	 * 记录页面
	 */
	// 1.获取列表（搜索）
	getRecordList(data) {
		return baseRequest('/console/v1/get-danger-zone-history-lists', data);
	},
	/**
	 * 添加页面
	 */
	// 1.获取设备列表
	getDangerDevices(data) {
		return baseRequest('/console/v1/danger/get-school-device-lists', data);
	},
	// 2.获取负责人列表
	getPrincipleList(data) {
		return baseRequest('/console/v1/get-teacher-school', data);
	},
	// 3.添加
	addDanger(data) {
		return baseRequest('/console/v1/add-danger-zone', data);
	},
	/**
	 * 修改页面
	 */
	// 1.获取详情
	getDangerDetail(data) {
		return baseRequest('/console/v1/get-danger-zone-details', data);
	},
	// 2.修改
	updateDanger(data) {
		return baseRequest('/console/v1/update-danger-zone', data);
	},
	/** ----------------------------------------------------
	 * 一键报警
	 -----------------------------------------------------*/
	// 获取设备列表
	getAlarmDeviceList(data) {
		return baseRequest('/console/v1/get-early-warning-device-lists', data);
	},
	// 获取预警记录
	getAlarmRecordList(data) {
		return baseRequest('/console/v1/get-early-warning-history-lists', data);
	},
	// 添加预警规则
	addAlarmRule(data) {
		return baseRequest('/console/v1/add-early-warning-rule', data);
	},
	// 编辑预警规则
	editAlarmRule(data) {
		return baseRequest('/console/v1/update-early-warning-rule', data);
	},
	// 根据id获取预警规则
	getAlarmRule(data) {
		return baseRequest('/console/v1/get-early-warning-rule-details', data);
	},
	// 删除一键报警规则
	deleteAlarmRule(data) {
		return baseRequest('/console/v1/del-early-warning-rule', data);
	},
	/** ----------------------------------------------------
	 * 黑名单
	 -----------------------------------------------------*/
	// 批量导入黑名单
	importBlackList(data) {
		return baseRequest('/console/v1/adds-blacklist', data);
	},
	// 单个导入黑名单
	addBlack(data) {
		return baseRequest('/console/v1/add-blacklist', data);
	},
	// 获取黑名单列表
	getBlackList(data) {
		return baseRequest('/console/v1/get-blacklist-lists', data);
	},
	// 获取黑名单详情
	getBlackDetail(data) {
		return baseRequest('/console/v1/get-blacklist-details', data);
	},
	// 编辑黑名单
	blackEdit(data) {
		return baseRequest('/console/v1/update-blacklist', data);
	},
	// 删除黑名单
	blackRemove(data) {
		return baseRequest('/console/v1/del-blacklist', data);
	},
	// 获取统计数据
	getBlackStatistics(data) {
		return baseRequest('/console/v1/blacklist-grade-statistics', data);
	},
	// 上传人脸接口
	publishFace(data) {
		return baseRequest('/publics/v1/upload-blacklist-img', data);
	},
	// 获取设备
	getBlackDevice(data) {
		return baseRequest('/console/v1/get-blacklist-device-lists', data);
	},
	// 修改设备的状态
	setDeviceStatus(data) {
		return baseRequest('/console/v1/update-blacklist-device', data);
	},
	// 获取负责人列表
	getPrincipleStatus(data) {
		return baseRequest('/console/v1/get-blacklist-teacher', data);
	},
	// 修改负责人状态
	setPrincipleStatus(data) {
		return baseRequest('/console/v1/update-switch-teacher', data);
	},
	// 获取预警记录
	getBlackRecord(data) {
		return baseRequest('/console/v1/get-blacklist-history-lists', data);
	},
	// 获取黑明单记录统计
	getBlackComulative(data) {
		return baseRequest('/console/v1/get-blacklist-history-cumulative', data);
	},
	// 获取教师最高职位
	getTeacherPosition(data) {
		return baseRequest('/console/v1/get-teacher-top-position', data);
	},
	/**
	 * 萌萌播列表页面
	 */
	// 1.获取列表数据（搜索）
	getSinatv(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device`,
			headers: config.headers,
			params
		});
	},
	// 2.获取列表数据（搜索）(新)
	getSinatvList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 萌萌播通道列表页面
	 */
	// 1.获取通道列表数据
	getChannel(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/channel`,
			headers: config.headers,
			params
		});
	},
	// 2.获取通道列表数据(新)
	getChannelList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/get-channel`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 萌萌播通道列表页面
	 */
	// 1.获取通道列表数据
	getChannelSetting(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/channel/info`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 萌萌播更新通道
	 */
	// 萌萌播v2_通道_更新通道
	getRenewal(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/channel/join`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播添加通道
	 */
	// 萌萌播v2_通道_添加通道
	getAddsubmit(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 萌萌播v2_通道_添加通道(新版)
	getAddsubmitNew(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播添加通道
	 */
	// 萌萌播v2_通道_生成通道
	getCreate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/channel/init/count`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播删除通道
	 */
	// 萌萌播v2_设备_删除一个  需要完善
	deleteAisle(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/delete`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 萌萌播修改通道
	 */
	// 萌萌播v2_通道_修改设备状态  编辑通道
	alterAisle(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播设置是否开启gbs服务
	 */
	// 萌萌播v2_通道_设置是否开启gbs服务
	setGbs(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/set_is_gbs_stream`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播更新视频截图
	 */
	// 萌萌播v2_通道_更新视频截图
	updateVideoImage(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/update_video_image`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播修改通道信息
	 */
	// 萌萌播v2_通道_修改通道信息
	alterAisleSetting(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/channel`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 萌萌播添加设备页面页面
	 */
	// 1.获取添加设备页面数据
	getAddSetup(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/create`,
			headers: config.headers,
			params
		});
	},
	// 萌萌播视频预览url
	/**
	 * 萌萌播视频预览url
	 */
	getInitVideo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/channel/video`,
			headers: config.headers,
			params
		});
	},
	// 获取学校直播订单列表
	getOrderList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-video/order-list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 设置萌萌播保活时长
	setKeepAlive(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/set_keep_alive`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 添加、编辑推流盒子配置
	addConfig(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/add-config`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 配置详情
	getConfig(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/config`,
			headers: config.headers,
			params
		});
	},
	// 添加、编辑取流方式
	operationGetStreamType(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/operation-get-stream-type`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除取流方式
	deleteGetStreamType(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/delete-get-stream-type`,
			headers: config.headers,
			params
		});
	},
	// 添加公共资料
	addCommonConfig(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/add-common-config`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑公共资料
	updateCommonConfig(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/update-common-config`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 取流方式列表
	getStreamTypeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/get-stream-type-list`,
			headers: config.headers,
			params
		});
	},
	// 根据设备id获取公共资料
	getCommonByDevId(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/get-common-by-dev-id`,
			headers: config.headers,
			params
		});
	},
	// 连通测试
	checkConnect(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/check-connect`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 设置推流模式、传输模式
	setStreamMode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/update-device-mode`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 设置音量
	setAudio(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/update-audio`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 设置音量
	setDeviceNpc(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/restart-device`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//搜索摄像头
	searchVideo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/search_video`,
			headers: config.headers,
			params
		});
	},
	//获取摄像头配置信息
	getVideo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_video`,
			headers: config.headers,
			params
		});
	},
	//添加摄像头
	addVideo(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/add_video`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//获取添加摄像头结果
	addVideoResult(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_add_video_result`,
			headers: config.headers,
			params
		});
	},
	//批量设置通道区域信息
	set_channel_region(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/set_channel_region`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//通过通道id初始化通道配置
	channel_init(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/channel_init`,
			headers: config.headers,
			params
		});
	},
	//获取推流信息
	get_stream_config(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_stream_config`,
			headers: config.headers,
			params
		});
	},
	//添加/编辑推流信息
	add_stream_config(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/add_stream_config`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//更新截图接口
	print_screen(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/print_screen`,
			headers: config.headers,
			params
		});
	},
	//获取更新截图结果
	screen_response(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_print_screen_response`,
			headers: config.headers,
			params
		});
	},
	//网络测试接口
	network_testing(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/network_testing`,
			headers: config.headers,
			params
		});
	},
	//获取网络测试结果
	network_response(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_network_testing_response`,
			headers: config.headers,
			params
		});
	},
	//修改通道信息
	change_channel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/channel`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//通道tcp和udp切换
	set_stream(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/set_stream_transfer_mode`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//放大功能开关
	set_enlargement(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/set_enlargement`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//联通测试,预览视频
	check_connect(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/device/check-connect`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 批量设置主副码流
	set_stream_code(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/set_stream_code`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 切换云服务
	switchStreaming(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/set_cloud_platform`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//批量断流
	cutStreaming(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/batch_stop_stream`,
			headers: config.headers,
			params
		});
	},
	//获取萌萌播推流盒子设备列表
	get_device_list(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_device_list`,
			headers: config.headers,
			params
		});
	},
	//推流测试
	push_stream(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/push_stream`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//根据通道id设置码流
	set_channel_code(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/set_channel_code`,
			headers: config.headers,
			params
		});
	},
	//视频参数查询接口
	get_video_info(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_video_info`,
			headers: config.headers,
			params
		});
	},
	//下载推流点播数据
	log_oss_url(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_log_oss_url`,
			headers: config.headers,
			params
		});
	},
	//设置设备DNS配置
	set_dev_dns(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/set_dev_dns`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//获取通道设备状态
	channel_dev_status(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/channel_dev_status`,
			headers: config.headers,
			params
		});
	},
	//萌萌播v3_0_9复制设备通道信息
	copy_channel_info(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moe-play/v3/copy_channel_info`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//萌萌播v3_0_9根据学校id获取设备gbid列表
	get_device_gbid_list(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/get_device_gbid_list`,
			headers: config.headers,
			params
		});
	},
	//萌萌播v3_0_9检查通道是否初始化
	check_channel_init(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/v3/check_channel_init`,
			headers: config.headers,
			params
		});
	},
	//后台_行为告警_获取行为设备告警类型
	alarmTypeLists(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.face}/device/v1/behavior/alarm-type-lists`,
			headers: config.headers,
			params
		});
	},
	//后台_行为告警_获取行为设备告警记录列表
	getAlarmLists(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/device/v1/behavior/record/get-alarm-lists`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//后台_预警系统_获取预警设备列表
	getBehaviorDeviceLists(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.face}/console/v1/get-behavior-device-lists`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取最近设备重启的记录
	getRebootRecentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moe-play/device/get-reboot-recent-list`,
			headers: config.headers,
			params
		});
	}
};
export default safety;
